module.exports = __webpack_public_path__ + "img/image25@2x.ca2f022e.png";